import React from 'react';
import Wallet from './Wallet';
import SendMessageForm from './SendMessageForm';
import AddNote from './AddNote';
import Divider from '@material-ui/core/Divider';
import AddPhone from "./Phones/AddPhone"
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  divider: {
    margin: theme.spacing(1, 0),
  },
}));

function CustomerFormCard(props) {
  const classes = useStyles();
  return (
    <>
      <Wallet />
      <Divider className={classes.divider} />
      <SendMessageForm />
      <Divider className={classes.divider} />
      <AddNote />
      <AddPhone />
    </>
  );
}

export default CustomerFormCard;
